import request from '../../../request/request';

const getProductPortal = () => {
  return request({ url: '/webapi/product/portal' });
};

const getUserSummary = ({ userName }) => {
  return request(`/api/users/${userName}/summary`);
};

export { getProductPortal, getUserSummary };
